import React from "react";
import "./RoofTypeTab.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";

const roofTypes = [
  {
    id: 1,
    name: "Douglas Platdak",
    imageUrl: "./images/platdak.png",
    color: "",
    value: "platdak",
    price: 0,
    description: "",
  },
  {
    id: 2,
    name: "Douglas Modern",
    imageUrl: "./images/modern.png",
    color: "",
    value: "modern",
    price: 0,
    description: "",
  },
  {
    id: 3,
    name: "Douglas Basisconstructie",
    imageUrl: "./images/basic.png",
    color: "",
    value: "basic",
    price: 0,
    description: "",
  },
  {
    id: 4,
    name: "Douglas Kapschuur",
    imageUrl: "./images/kapschuur.png",
    color: "",
    value: "kapschuur",
    price: 0,
    description: "",
  },
];

const RoofTypeTab: React.FC = () => {
  const { state, setRoofType, setWalls, setOptionsMaterial } =
    useConfiguration();

  const handleRoofTypeChange = (roofType: string) => {
    if (roofType === "basic" && state.walls.length > 0) {
      setWalls([]);
    }
    if (
      roofType === "kapschuur" &&
      state.optionsMaterial.shorenType !== "default"
    ) {
      setOptionsMaterial({
        ...state.optionsMaterial,
        shorenType: "default",
      });
    }
    if (state.roofType !== roofType) setRoofType(roofType);
  };

  return (
    <div className="roof-type-tab">
      {/* <Text content="Kies uw afmetingen" /> */}
      <RadioBlocksExtended
        blocks={roofTypes}
        value={state.roofType}
        onChange={handleRoofTypeChange}
        className="root-type-radio-blocks"
        variant="square"
      />
    </div>
  );
};

export default RoofTypeTab;
